// project-imports
import { postRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - MAIL ||============================== //

export async function handleMail(action: APIAction) {
  switch (action.method) {
    case 'welcome-paid':
      return postRequest('/mail/welcome-paid', action.data, true);
    case 'welcome-freemium':
      return postRequest('/mail/welcome-freemium', action.data, true);
    default:
      console.info('[ApiManager > handleApiAction > handleMail] - Unknown method');
      break;
  }
}
